module.exports = __webpack_public_path__ + "img/keno_retail.3e07d8a0.png";